import React, { useEffect, useState } from 'react';

import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import api from '../../../services/api';
import TableContent from './TableContent';
import OperationsMiddle from './OperationsMiddle';
import { useParams } from 'react-router-dom';

import * as S from './styles';
import { useMessageBox } from '../../../context/MessageBox';
import { useNotification } from '../../../context/NotificationContext';
import { TOKEN_USER } from '../../../services/auth';
import Loading from '../../../components/Loading';

export function PeriodReport() {
  const { periodo, anchorId } = useParams();
  const { setAnchorId } = useNotification();

  const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.loginId;
  const [anchors, setAnchors] = useState({});
  const [selectedAnchor, setSelectedAnchor] = useState(null);

  const [selectedProvider, setSelectedProvider] = useState('');
  const [providerInfo, setProviderInfo] = useState([]);
  const [proposeProps, setProposeProps] = useState({ isPropose: false, origin: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [loader, setLoader] = useState(true);
  const [updateInfo, setUpdateInfo] = useState({ origin: '', id: null, canUpdate: false });
  const [intervalTime, setintervalTime] = useState(0);
  const [tableData, setTableData] = useState();
  const [totalTableData, setTotalTableData] = useState();
  const [onlyApproved, setOnlyApproved] = useState(true);
  const [triggerUpdate, setTriggerUpdate] = useState(true);

  const [screenParams, setScreenParams] = useState({
    title: periodo === 'diario' ? 'Relatório Diário' : 'Relatório Mensal',
    moduloId: periodo === 'diario' ? 'Relatorio003Diario' : 'Relatorio004Mensal',
  });

  const [updateContent, setUpdateContent] = useState(Date.now());
  const reloadPage = async (
    provider,
    origemParam = '',
    proposePropsParam = { isPropose: false, origin: '' },
  ) => {
    setTimeout(() => {
      setSelectedProvider({ ...provider, origemProv: origemParam });
      setProviderInfo(provider);
      setProposeProps(proposePropsParam);
    }, 1);
  };

  const fetchAvailableAnchors = async () => {
    // const message = await api.put('_API/MensagemBoxParametrosDefinidos');
    // setMessageData(message?.data?.complemento?.mensagensBox);
    const { data } = await api.get(
      `Relatorios/ConsultarPlataformasAncorasAnalistas?loginId=${loginId}&moduloId=${screenParams.moduloId}`,
    );

    if(data.resposta.redes || data.resposta.plataformas || data.resposta.redeCapittale) {
      var anchor = data.resposta.redeCapittale.ancoraId > 0 ? data.resposta.redeCapittale :
      (data.resposta?.redes.length > 0 ? data.resposta?.redes[0] : 
        (data.resposta?.plataformas.length > 0 ? data.resposta.plataformas[0]: {}));
      setAnchors(data.resposta);
      if (anchorId) {
        anchor =
					data.resposta.redes.find((x) => x.ancoraId == anchorId) ||
					data.resposta.plataformas.find((x) => x.plataformaId == anchorId);
        if (anchor){
					setSelectedAnchor(anchor);
					setAnchorId(
						anchor.ancoraId
							? anchor.ancoraId
							: anchor.plataformaId
							? anchor.plataformaId
							: 0
					);
				}
			} 
      else {
        setSelectedAnchor(anchor);
				setAnchorId(
					anchor.ancoraId
						? anchor.ancoraId
						: anchor.plataformaId
						? anchor.plataformaId
						: 0
				);
      }
      
    } else if (data.resposta.length > 0) {
      setAnchors(data.resposta);
      setSelectedAnchor(data.resposta[0]);
      setAnchorId(data.resposta[0].ancoraId);
    } else {
      setAnchors([]);
      setSelectedAnchor({});
      setAnchorId(0);
    }
  };

  const handleSelectAnchor = (anchor) => {
    setAnchorId(anchor?.ancoraId);
    setSelectedAnchor(anchor);
    setSelectedProvider('');
    setTriggerUpdate(true);
  };

  useEffect(() => {
    if (intervalTime > 0) {
      const interval = setInterval(() => setUpdateContent(Date.now()), intervalTime);
      return () => {
        clearInterval(interval);
      };
    }
  }, [intervalTime]);

  useEffect(() => {
    fetchAvailableAnchors();
    setintervalTime(
      Number(
        JSON.parse(
          sessionStorage.getItem('@Capittale-Web-Setting'),
        )?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 40)?.valor ?? 0,
      ) *
        1000 *
        60,
    );
  }, []);

  useEffect(() => {
    isLoading
      ? localStorage.setItem('isLoading', 'true')
      : localStorage.setItem('isLoading', 'false');
    setTimeout(() => {
      setLoader(localStorage.getItem('isLoading') === 'true');
    }, 200);
  }, [isLoading]);

  return (
    <S.Root>
      <Header />
      <Subheader title={screenParams.title} back="/app/home" />
      <S.Content>
        <div
          style={{
            width: '100%',
            margin: '30px 30px',
            padding: '0px 20px 20px 20px',
            height: '100%',
            border: '2px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#eee',
          }}
        >
          <OperationsMiddle
            selectedAnchor={selectedAnchor}
            setTableData={setTableData}
            setTotalTableData={setTotalTableData}
            setOnlyApproved={setOnlyApproved}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            triggerUpdate={triggerUpdate}
            setTriggerUpdate={setTriggerUpdate}
            anchors={anchors}
            handleSelectAnchor={handleSelectAnchor}
          />
        </div>
      </S.Content>
      {loader ? (
        <Loading />
      ) : (
        <div>
          <TableContent
            tableData={tableData}
            totalTableData={totalTableData}
            onlyApproved={onlyApproved}
            selectedAnchor={selectedAnchor}
          />
        </div>
      )}
    </S.Root>
  );
}
